<template>
  <a-tabs default-active-key="1">
    <a-tab-pane tab="Procesamiento" key="1">
      <a-row :gutter="[16,16]">
        <a-col :xs="24" :sm="24" :md="16">
          <a-card>
            <a-spin :spinning="loading">
              <a-form-model :model="processData" :rules="rules" ref="processForm">
                <a-row :gutter="[5,5]">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Compañía')" prop="id_company">
                      <form-model-dropdown style="width: 100%"
                                           endpoint="company"
                                           v-model="processData.id_company"
                      >
                      </form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Año')" prop="year">
                      <a-input-number style="width: 100%;"
                                      step="1"
                                      v-model="processData.year">
                      </a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Mes')" prop="month">
                      <a-input-number style="width: 100%;"
                                      step="1"
                                      v-model="processData.month">
                      </a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Periodo')" prop="periodo">
                      <form-model-dropdown style="width: 100%"
                                           v-model="processData.periodo"
                                           endpoint="hierarchy_lookup"
                                           :params="period_request"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Proceso')" prop="proceso">
                      <form-model-dropdown style="width: 100%"
                                           v-model="processData.proceso"
                                           endpoint="hierarchy_lookup"
                                           :selectedObj.sync="procesoSeleccionado"
                                           :params="proceso_request"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Fecha Inicio')" prop="fecha_inicio">
                      <a-date-picker
                        v-model="processData.fecha_inicio"
                        type="date"
                        style="width: 100%;"
                        valueFormat="Y-MM-DD HH:mm:ss"
                        :disabled="fechasDesactivadas"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Fecha Fin')" prop="fecha_fin">
                      <a-date-picker
                        v-model="processData.fecha_fin"
                        type="date"
                        style="width: 100%;"
                        valueFormat="Y-MM-DD HH:mm:ss"
                        :disabled="fechasDesactivadas"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Localidad')" prop="localidad_id" has-feedback>
                      <form-model-dropdown style="width: 100%"
                                           endpoint="offices"
                                           v-model="processData.localidad_id">
                      </form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Tipo Pago')" prop="tipo_pago">
                      <form-model-dropdown style="width: 100%"
                                           v-model="processData.tipo_pago"
                                           endpoint="hierarchy_lookup"
                                           :params="tipo_pago_request"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Fecha Pago')" prop="fecha_pago">
                      <a-date-picker
                        v-model="processData.fecha_pago"
                        type="date"
                        style="width: 100%;"
                        valueFormat="Y-MM-DD HH:mm:ss"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Tipo Liquidacion')" prop="tipo_liquidacion">
                      <form-model-dropdown style="width: 100%"
                                           v-model="processData.tipo_liquidacion"
                                           endpoint="hierarchy_lookup"
                                           :params="tipo_liq_request"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Empleado')" prop="id_emp">
                      <form-model-lookup style="width: 100%"
                                         endpoint="empleados"
                                         v-model="processData.id_emp"
                                         :params="empleado_params"
                                         :cache="false">
                        <!--:selectedObj.sync="empleadoAutorizaSeleccionado"-->
                      </form-model-lookup>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('ID Referencia')" prop="id_referencia">
                      <a-input style="width: 100%;"
                               v-model="processData.id_referencia">
                      </a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="18">
                    <a-row style="text-align: right; padding-top: 40px;">
                      <a-button type="primary" @click="ejecutar('procesar')">
                        Procesar
                      </a-button>
                      <a-button style="background-color: #a9b52f; color: white; border-color: #a9b52f;"
                                @click="ejecutar('reversar')">
                        Reversar
                      </a-button>
                      <a-button v-if="ocultarToNovelty" type="danger" @click="ejecutar('cerrar')">
                        Cerrar
                      </a-button>
                    </a-row>
                  </a-col>
                </a-row>
              </a-form-model>
            </a-spin>
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="24" :md="8">
          <a-card>
            <template v-if="processStatus.proceso">
              <a-row>
                <a-col :span="8" style="text-align: center">
                  <a-progress type="circle" :percent="processStatus.total_percent"
                              :format="percent => `Registros ${processStatus.total}`" :status="graphStatus"/>
                </a-col>
                <a-col :span="8" style="text-align: center">
                  <a-progress type="circle" :percent="processStatus.procesados_percent"
                              :format="percent => `Procesados ${processStatus.procesados}`" :status="graphStatus"/>
                </a-col>
                <a-col :span="8" style="text-align: center">
                  <a-progress type="circle" :percent="processStatus.pendientes_percent"
                              :format="percent => `${processStatus.status === 'RUNNING'?'Pendientes':'Ignorados'} ${processStatus.pendientes}`"
                              :status="graphStatus"/>
                </a-col>
              </a-row>

              <a-progress :percent="processStatus.porcent" :status="graphStatus"/>
              <div>&nbsp;</div>
              <a-alert
                message="En ejecución."
                description="Se está ejecutando el proceso solicitado. Por favor espere..."
                type="info"
                show-icon
                v-if="graphStatus === 'normal'"
              />
              <a-alert
                message="Error."
                :description="`El proceso ha fallado, con mensaje: ${processStatus.mensaje}`"
                type="error"
                show-icon
                v-if="graphStatus === 'exception'"
              />
              <a-alert
                message="Finalizado."
                :description="`El proceso ha finalizado correctamente, mensaje: ${processStatus.mensaje}.`"
                type="success"
                show-icon
                v-if="graphStatus === 'success'"
              />
            </template>
            <a-alert
              v-else
              message="No hay procesos disponibles"
              description="El usuario no tiene procesos disponibles."
              type="info"
              show-icon
            />
          </a-card>
          <br/>
          <a-card>
            <h1>Enlaces de Interés</h1>
            <a href="/app/#/consultas/acumulados" class="href">Consulta de Acumulados</a>
            <a-divider type="vertical"/>
            <a href="/app/#/consultas/plano_ss_2388" class="href">Consulta de Seguridad Social</a>
            <a-divider type="vertical"/>
            <a href="/app/#/consultas/contabilidad" class="href">Consulta de Contabilidad</a>
          </a-card>
        </a-col>
        <a-col :xs="24">
          <a-tabs default-active-key="1">
            <a-tab-pane tab="Histórico de Procesamiento" key="1">
              Trabajo en progreso...
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
      <a-modal title="Confirmación"
               :visible="confirmModalVisible"
               :confirmLoading="confirmModalLoading"
               :closable="!confirmModalLoading"
               @ok="confirmarProceso"
               @cancel="cancelarProceso"
               :okText="procesoAejecutar === 'cerrar' ? 'Cerrar' : (procesoAejecutar === 'reversar' ? 'Reversar' : 'Procesar' )"
               cancelText="Cancelar"
               width="50%">
        <a-result
          :status="procesoAejecutar === 'cerrar' ? 'warning' : 'info'"
          title="Advertencia"
          sub-title="Tenga en cuenta que solo puede tener un proceso ejecutándose de manera simultanea."
          style="padding: 5px 32px;">
          <div class="desc">
            <p style="font-size: 16px;">
              <strong>Consideraciones antes de realizar este proceso:</strong>
            </p>
            <p v-for="tip in consideraciones.cerrar" v-if="procesoAejecutar === 'cerrar'">
              <a-icon :style="{ color: 'orange' }" type="exclamation-circle"/>
              {{tip}}
            </p>
            <p v-for="tip in consideraciones.procesar" v-if="procesoAejecutar === 'procesar'">
              <a-icon :style="{ color: 'orange' }" type="exclamation-circle"/>
              {{tip}}
            </p>
            <p v-for="tip in consideraciones.reversar" v-if="procesoAejecutar === 'reversar'">
              <a-icon :style="{ color: 'orange' }" type="exclamation-circle"/>
              {{tip}}
            </p>
          </div>
        </a-result>
        <a-alert v-if="confirmModalError" :message="confirmModalError" type="error" show-icon/>
      </a-modal>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        colSpan: {
          xs: 24,
          md: 6
        },
        period_request: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        proceso_request: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        tipo_liq_request: {
          h_lookup_type: 'TIPO_LIQUIDACION',
          use_code: true
        },
        tipo_pago_request: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        processStatus: {
          loading: false,
          status: 'RUNNING', // RUNNING FAILED FINISHED
          procesados: 0,
          procesados_percent: 0,
          pendientes: 0,
          pendientes_percent: 0,
          total: 0,
          porcent: 0,
          proceso: false,
          mensaje: ''
        },
        processData: {
          id_emp: null,
          id_company: null,
          tipo_pago: null,
          tipo_liquidacion: null,
          localidad_id: null,
          year: null,
          month: null,
          periodo: null,
          fecha_inicio: null,
          fecha_fin: null
        },
        fechasDesactivadas: false,
        consultaFechasLastRequest: null,
        consultaFechaTimeout: null,
        fechasRequestCount: 0,
        procesoSeleccionado: {},
        rules: {
          id_company: [{required: true, message: 'Valor requerido'}],
          year: [{required: true, message: 'Valor requerido'}],
          month: [{required: true, message: 'Valor requerido'}],
          periodo: [{required: true, message: 'Valor requerido'}],
          fecha_inicio: [{required: true, message: 'Valor requerido'}],
          fecha_fin: [{required: true, message: 'Valor requerido'}],
          proceso: [{required: true, message: 'Valor requerido'}]
        },
        procesoAejecutar: null,
        confirmModalVisible: false,
        confirmModalLoading: false,
        confirmModalError: false,
        consideraciones: {
          cerrar: [
            'Este proceso no puede ser reversado',
            'Solo puede tener un proceso de cierre ejecutandose simultaneamente'
          ],
          procesar: [
            'Solo puede tener un proceso ejecutandose simultaneamente'
          ],
          reversar: [
            'Solo puede tener un proceso ejecutandose simultaneamente',
            'Solo es posible reversar una vez haya terminado la ejecución del proceso'
          ]
        },
        updateGraphTimeout: null,
        loading: false,
        initialPayrollParameter: false
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.getPayrollParameter()
      this.updateGraphTimeout = setTimeout(this.consultaEstado, 1000)
    },
    beforeDestroy () {
      this.updateGraphTimeout && clearTimeout(this.updateGraphTimeout)
    },
    methods: {
      limpiarEmpleado () {
        this.processData.id_emp = null
      },
      procesarAnoMesPeriodo (requestNumber) {
        if (this.initialPayrollParameter) {
          return
        }
        this.processData.fecha_inicio = null
        this.processData.fecha_fin = null

        if (!JsUtils.isEmpty(this.processData.year) && !JsUtils.isEmpty(this.processData.month) && !JsUtils.isEmpty(this.processData.periodo)) {
          this.fechasDesactivadas = true
          try {
            this.consultaFechasLastRequest && this.consultaFechasLastRequest.cancel()
          } catch (e) {
          }
          this.consultaFechasLastRequest = this.httpClient.getInstance().get('procesamiento/consulta_payroll_callendar', {
            params: {
              year: this.processData.year,
              month: this.processData.month,
              periodo: this.processData.periodo
            }
          }).then((response) => {
            if (this.fechasRequestCount === requestNumber) {
              this.processData.fecha_inicio = moment(response.data.dtini).format('Y-MM-DD HH:mm:ss')
              this.processData.fecha_fin = moment(response.data.dtend).format('Y-MM-DD HH:mm:ss')
            }
          }).catch(() => {
            if (this.fechasRequestCount === requestNumber) {
              Mensajes.warning('Advertencia', 'No hay un calendario de pagos configurado para el año/mes seleccionado.')
            }
          }).then(() => {
            if (this.fechasRequestCount === requestNumber) {
              this.fechasDesactivadas = false
            }
          })
        }
      },
      ejecutar (proceso) {
        this.$refs.processForm && this.$refs.processForm.validate(valid => {
          if (!valid) return
          /* validamos la seleccion de fecha final */
          if (this.processData.proceso === '1' && this.processData.periodo === '4') {
            /* Validamos si el mes es de 31 días la fecha final debe ser 31 */
            let ff = this.processData.fecha_fin
            if (!moment.isMoment(ff)) {
              ff = moment(this.processData.fecha_fin)
            }
            let endOfMonth = ff.clone().endOf('month')
            if (endOfMonth.date() !== ff.date()) {
              Mensajes.warning('Verificar', 'Cuando se realiza el proceso de liquidación mensual la fecha final debe ser el último día del mes.')
              return
            }
          }

          this.procesoAejecutar = proceso
          this.confirmModalVisible = true
        })
      },
      confirmarProceso () {
        this.confirmModalLoading = true
        this.confirmModalError = false
        this.httpClient.getInstance().post('procesamiento/ejecutar_proceso/' + this.procesoAejecutar, this.processData)
          .then(response => {
            Mensajes.success('Correcto', 'Proceso programado satisfactoriamente')
            this.confirmModalVisible = false
            this.updateGraphTimeout = setTimeout(this.consultaEstado, 3000)
            // TODO ACTUALIZAR LA TABLA DEL DETALLE
          })
          .catch(error => {
            this.confirmModalError = this.$getErrorMessage(error, 'Error inesperado, contacte al administrador')
          })
          .then(() => {
            this.confirmModalLoading = false
          })
      },
      cancelarProceso () {
        if (this.confirmModalLoading) {
          return
        }
        this.procesoAejecutar = null
        this.confirmModalVisible = false
        this.confirmModalLoading = false
      },
      consultaEstado () {
        this.processStatus.loading = true
        this.httpClient.getInstance().get('procesamiento/consulta_estado')
          .then((response) => {
            this.processStatus.proceso = response.data.proceso
            if (this.processStatus.proceso) {
              this.processStatus.total = response.data.total
              this.processStatus.total_percent = 100
              this.processStatus.procesados = response.data.procesados
              this.processStatus.pendientes = response.data.pendientes
              this.processStatus.mensaje = response.data.mensaje

              this.processStatus.procesados_percent = parseInt(parseInt(response.data.procesados) / parseInt(response.data.total) * 100)
              this.processStatus.pendientes_percent = parseInt(parseInt(response.data.pendientes) / parseInt(response.data.total) * 100)

              this.processStatus.status = response.data.status
              this.processStatus.porcent = this.processStatus.procesados_percent

              if (this.processStatus.status === 'RUNNING') {
                this.updateGraphTimeout = setTimeout(this.consultaEstado, 3000)
              }
            }
          })
          .catch(() => {
            this.processStatus.total = 0
            this.processStatus.procesados = 0
            this.processStatus.pendientes = 0
            this.processStatus.status = 0
            this.processStatus.porcent = 0
            this.processStatus.proceso = false
          })
          .then(() => {
            this.processStatus.loading = false
          })
      },
      getPayrollParameter () {
        this.initialPayrollParameter = true
        this.loading = true
        this.httpClient.getInstance().get('procesamiento/payroll_parameter')
          .then((response) => {
            if (!this.$isEmpty(response.data)) {
              this.processData = {
                id_company: response.data.company,
                year: response.data.year,
                month: response.data.month,
                periodo: response.data.period,
                proceso: response.data.prc,
                fecha_inicio: response.data.dtini,
                fecha_fin: response.data.dtend,
                localidad_id: response.data.location,
                tipo_pago: response.data.tpay,
                fecha_pago: response.data.dtpay,
                tipo_liquidacion: response.data.tliq,
                id_emp: response.data.empid,
                id_referencia: response.data.reference_id
              }
            }
          })
          .catch((error) => {
            Mensajes.error(this.$getErrorMessage(error, 'Error inesperado. Consulte al administrador.'))
          })
          .then(() => {
            this.loading = false
            this.initialPayrollParameter = false
          })
      }
    },
    watch: {
      'processData.id_company': function () {
        this.limpiarEmpleado()
      },
      'processData.tipo_pago': function () {
        this.limpiarEmpleado()
      },
      'processData.tipo_liquidacion': function () {
        this.limpiarEmpleado()
      },
      'processData.localidad_id': function () {
        this.limpiarEmpleado()
      },
      'processData.year': function () {
        if (this.initialPayrollParameter) {
          return
        }
        this.consultaFechaTimeout && clearTimeout(this.consultaFechaTimeout)
        let cnt = ++this.fechasRequestCount
        this.consultaFechaTimeout = setTimeout(() => {
          this.procesarAnoMesPeriodo(cnt)
        }, 300)
      },
      'processData.month': function () {
        if (this.initialPayrollParameter) {
          return
        }
        this.consultaFechaTimeout && clearTimeout(this.consultaFechaTimeout)
        let cnt = ++this.fechasRequestCount
        this.consultaFechaTimeout = setTimeout(() => {
          this.procesarAnoMesPeriodo(cnt)
        }, 300)
      },
      'processData.periodo': function () {
        if (this.initialPayrollParameter) {
          return
        }
        this.consultaFechaTimeout && clearTimeout(this.consultaFechaTimeout)
        let cnt = ++this.fechasRequestCount
        this.consultaFechaTimeout = setTimeout(() => {
          this.procesarAnoMesPeriodo(cnt)
        }, 300)
      }
    },
    computed: {
      graphStatus () {
        if (!this.processStatus.proceso) {
          return ''
        }
        switch (this.processStatus.status) {
          case 'RUNNING':
            return 'normal'
          case 'FAILED':
            return 'exception'
          case 'FINISHED':
            return 'success'
        }
        return ''
      },
      empleado_params () {
        let result = {
          estado: 'N'
        }

        let paramsToCheck = [
          'id_company',
          'tipo_pago',
          'tipo_liquidacion',
          'localidad_id'
        ]
        if (this.procesoSeleccionado.hasOwnProperty('text') && this.procesoSeleccionado.text.includes('RELIQUIDACION DEFINITIVA')) {
          result['estado'] = 'R'
        }

        if (this.$getConfigValue('PROCESAR_PRV_SSO_EMPLEADOS_RETIRADOS') === 'SI') {
          if (this.procesoSeleccionado.hasOwnProperty('text') &&
            (this.procesoSeleccionado.text.includes('PROVISIONES') || this.procesoSeleccionado.text.includes('SEGURIDAD SOCIAL'))) {
            return {
              empleados_prv_sso: true,
              year: this.processData.year,
              mes: this.processData.month
            }
          }
        }

        paramsToCheck.map(param => {
          if (!JsUtils.isEmpty(this.processData[param])) {
            result[param] = this.processData[param]
          }
        })

        return result
      },
      ocultarToNovelty () {
        if (this.$userIsInrol('Novelty')) {
          return this.$getConfigValue('OCULTAR_BTN_CERRAR_PROCESAMIENTO', 'NO') === 'NO'
        }
        return true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Procesamiento/Procesamiento.vue